<template>
  <div>
    <Header></Header>
    <Expired v-if="error == 'Error'"></Expired>
    <div v-else class="sign_up_page">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 order-2 order-lg-1">
            <div class="sign_up_box">
              <h1>{{ $t("auth.reset.title") }}</h1>
              <template v-if="response">
                <p>{{ $t("auth.reset.changed") }}</p>
                <hr />
                <p class="text-center small">
                  <router-link to="/login">{{
                    $t("auth.reset.signin")
                  }}</router-link>
                </p>
              </template>
              <template v-else>
                <p>
                  {{ $t("auth.reset.instructions") }}
                  <br />
                  {{ $t("auth.reset.sessions_note") }}
                </p>
                <div v-if="show_password" class="input_box">
                  <div class="label">{{ $t("auth.reset.password") }}</div>
                  <input
                    type="text"
                    :placeholder="$t('auth.reset.placeholder')"
                    v-model="password"
                  />
                  <img
                    :src="require('@/assets/static/images/auth/pass_show.svg')"
                    alt=""
                    @click="show_password = false"
                  />
                </div>
                <div v-else class="input_box">
                  <div class="label">{{ $t("auth.reset.password") }}</div>
                  <input
                    type="password"
                    :placeholder="$t('auth.reset.placeholder')"
                    v-model="password"
                  />
                  <img
                    :src="require('@/assets/static/images/auth/pass_hide.svg')"
                    alt=""
                    @click="show_password = true"
                  />
                </div>
                <div v-if="error" class="error_msg">{{ error }}</div>
                <div
                  class="auth-button"
                  :class="button_disabled ? 'active' : ''"
                >
                  <a href="#" class="button" @click.prevent="submitForm">{{
                    $t("auth.reset.button")
                  }}</a>
                  <div class="image-pre-loader image-pre-loader-red"></div>
                </div>
                <hr />
                <p class="text-center small">
                  {{ $t("auth.reset.need_help") }}
                  <a :href="url">{{
                    $t("auth.reset.contact_support")
                  }}</a>
                </p>
              </template>
            </div>
          </div>
          <div class="col-lg-6 order-1 order-lg-2">
            <div class="key_img">
              <img
                :src="require('@/assets/static/images/auth/key.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/auth/main.scss";
import { mapMutations, mapActions, mapGetters } from "vuex";
import passwordValidator from "password-validator";

import Header from "@/components/auth/Header";
import Expired from "@/components/auth/Expired";

export default {
  data: () => ({
    password: "",
    error: "",
    button_disabled: false,
    show_password: false,
    password_valid: false,
    response: false,
  }),
  components: {
    Header,
    Expired,
  },
  computed: {
    url() {
      return process.env.VUE_APP_SUPPORT_PAGE &&
        process.env.VUE_APP_SUPPORT_PAGE !== "#"
        ? process.env.VUE_APP_SUPPORT_PAGE
        : "https://taskpal.com/submit-a-ticket/";
    },
  },
  mounted() {
    document.head.querySelector("[name~=theme-color][content]").content =
      "#fff";
    document.head.querySelector("[name~=viewport][content]").content =
      "width=device-width,initial-scale=1.0";
    document.querySelector("body").classList.add("responsive");
    this.check_url_decrypt();
    document.querySelector("body").classList.add("intropage");
  },
  unmounted() {
    document.querySelector("body").classList.remove("intropage");
  },
  methods: {
    ...mapActions(["NewPassword", "check_url"]),
    ...mapMutations(["setMessage"]),
    async check_url_decrypt() {
      const result = await this.check_url({
        url: this.$w_api.CHECK_URL,
        body: {
          code: this.$route.params.code,
        },
      });
      if (!result) {
        this.error = this.$t("auth.reset.error.error");
      }
    },
    async submitForm() {
      if (this.$route.params.code) {
        if (this.button_disabled) return;
        if (this.password_valid) return;

        this.error = "";

        if (!this.password)
          return (this.error = this.$t("auth.reset.error.required"));
        if (this.error != "") return;

        this.button_disabled = true;

        const result = await this.NewPassword({
          url: this.$w_api.NewPassword,
          body: {
            password: this.password,
            code: this.$route.params.code,
          },
        });

        if (result) {
          this.response = true;
        } else {
          setTimeout(() => {
            this.button_disabled = false;
            this.error = this.$t("auth.reset.error.error");
          }, 1000);
        }
      }
    },
  },
  watch: {
    password(e) {
      this.password_valid = true;
      if (e == "") {
        this.error = this.$t("auth.reset.error.required");
      } else {
        var schema = new passwordValidator();
        schema.is().min(8).is().max(100).is().not().oneOf(this.$w_password);

        let valid = schema.validate(e, { list: true });
        if (valid.length > 0) {
          if (valid[0] == "min") {
            this.error = this.$t("auth.reset.error.min");
          }
          if (valid[0] == "max") {
            this.error = this.$t("auth.reset.error.max");
          }
          if (valid[0] == "uppercase") {
            this.error = this.$t("auth.reset.error.uppercase");
          }
          if (valid[0] == "lowercase") {
            this.error = this.$t("auth.reset.error.lowercase");
          }
          if (valid[0] == "digits") {
            this.error = this.$t("auth.reset.error.digits");
          }
          if (valid[0] == "spaces") {
            this.error = this.$t("auth.reset.error.spaces");
          }
          if (valid[0] == "oneOf") {
            this.error = this.$t("auth.reset.error.easy_password");
          }
        } else {
          this.password_valid = false;
          this.error = "";
        }
      }
    },
  },
};
</script>
